<mat-card>
  <mat-toolbar>{{ 'contactesList.titol' | translate }}
    <span class="fill-remaining-space"></span>
    <button mat-icon-button matTooltip="{{ 'oportunitats.filtre' | translate }}" attr.aria-label="{{ 'oportunitats.filtre' | translate }}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
    <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="addContacte()" matTooltip="{{ 'contactesList.nou' | translate }}" attr.aria-label="{{ 'contactesList.nou' | translate }}" matTooltipClass="tooltip-style">
        <mat-icon color="primary" style="font-size:24px">add</mat-icon>
    </button>
    <button mat-icon-button matTooltip="{{ 'oportunitats.exportToolTip' | translate }}" attr.aria-label="{{ 'oportunitats.exportToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.exportar()" style="float: right; margin-right: 0">
      <mat-icon  color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-contactes-filters
      *ngIf="showFilters"
      [validFilters]="contactesFilters"
      (changeFilter)="computeActiveFilters($event)">
    </mcrit-gestio-contactes-filters>
    <table>
      <thead>
        <tr>
          <th *ngFor="let field of tableFields; let i = index" (click)="cycleOrdering(field[0])" style="vertical-align: top">
            {{field[1]}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters[field[0]] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters[field[0]] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="contactesData">
        <tr *ngFor="let contacte of contactesData.rows;" style="cursor:pointer">
          <td *ngFor="let field of tableFields;let i = index" (click)="editContacte(contacte)">
            <div style="float: left;clear: none;padding-right: 5px">&nbsp;{{contacte[field[0]]}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{ 'facturesRebList.liniesPag' | translate }}: {{listContactesService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="contactesData">
      {{ 'contactesList.resumRegistres' | translate:{ first: firstRegisterShown, last: lastRegisterShown, total: contactesData.registers } }}
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>
